'use strict';

export default function debounceRaf(callback) {
    let set = false;
    return function () {
        let args = arguments;
        if (set) {
            return;
        }
        set = true;
        requestAnimationFrame(function (t) {
            set = false;
            callback.apply(t, args);
        });
    };
}
